export const baseUrl = "https://support.getclockwise.com/";

export const articleUrls = {
  autopilot: `${baseUrl}hc/en-us/articles/360026698772-Flexible-Meeting-Overview`,
  autopilotFaq: `${baseUrl}hc/en-us/articles/360026753332-autopilot-faq`,
  colors: `${baseUrl}hc/en-us/articles/360026978991-color-coding`,
  feedback: `${baseUrl}hc/en-us/requests/new`,
  flexibilityFaq: `${baseUrl}/hc/en-us/articles/360026698772#h_01FRRFVP724S7E85ZHR984RKJ1`,
  focusTime: `${baseUrl}hc/en-us/articles/360026753272-focus-time`,
  noMeetingDay: `${baseUrl}hc/en-us/articles/360041160532-Team-features-Team-no-meeting-day`,
  personalCalSync: `${baseUrl}hc/en-us/articles/360026698872-personal-calendar-sync`,
  plans: `${baseUrl}hc/en-us/articles/360050334031-Clockwise-Plan-FAQs`,
  slack: `${baseUrl}hc/en-us/articles/360026698832-slack-sync`,
  focusTimeSync: `${baseUrl}hc/en-us/articles/360026753272-focus-time`,
  lunchSync: `${baseUrl}hc/en-us/articles/360027033951-lunch`,
  travelTime: `${baseUrl}hc/en-us/articles/360033059752-travel-time`,
  teamCalendar: `${baseUrl}hc/en-us/articles/360041037012-Shared-Team-Calendars`,
  zoom: `${baseUrl}hc/en-us/articles/360045373231-Zoom-integration-for-Scheduler`,
  schedulerOverview: `${baseUrl}hc/en-us/articles/360026978951-Scheduler-Overview`,
  scheduleAssists: `${baseUrl}hc/en-us/articles/360056956151-Clockwise-Plans`,
  holiday: `${baseUrl}hc/en-us/articles/4407682672916`,
  contactSharing: `${baseUrl}hc/en-us/articles/8659647014676-Contact-Sharing-Error`,
  smartMeetingBreaks: `${baseUrl}hc/en-us/articles/360060901092-Smart-Meeting-Breaks`,
  roundRobin: `${baseUrl}hc/en-us/articles/24609865165460`,
};
